import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

import { GroupingSchema, GroupingTypeEnum } from './taxonomy.js';

export const UpdateGroupingBodySchema = z.object({
  type: GroupingTypeEnum,
});

export const UpdateGroupingResponseSchema = createResponseSchema(
  GroupingSchema.omit({ labels: true }),
);
